import api from '@/services/api';

const MOVE_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[.!@])[A-Za-z\d.!@]{8,12}$/;

export default {
    data() {
        return {
            password: '',
            password2: '',
            showPassword: false,
            showPassword2: false,
            passwordTouched: false,
        };
    },

    computed: {
        isPasswordValid() {
            return MOVE_PASSWORD_REGEX.test(this.password);
        },
        showPasswordError() {
            return this.passwordTouched && !this.isPasswordValid;
        },
    },

    methods: {
        submitChangeTvPassword() {
            if (this.fieldsAreEmpty()) {
                return;
            }
            if (!this.isPasswordValid) {
                this.$toast.error(this.$i18n.t('messages.movePasswordValidation'));
                return;
            }
            if (this.passwordsDoNotMatch()) {
                return;
            }

            this.$Progress.start();
            const params = new URLSearchParams();

            params.append('password', this.password);
            api.post('/api/change-tv-password', params)
                .then(() => {
                    this.$toast.success(this.$i18n.t('messages.success'));
                    this.$Progress.finish();
                    this.resetInputs();
                }).catch((error) => {
                    if (error.response.data.code === 'CHANGED_TV_PASSWORD_FAILED_VALIDATION_ERROR' && error.response.data.body?.validation_errors?.password) {
                        this.$toast.error(error.response.data.body.validation_errors.password.join(', '))
                    } else {
                        this.$toast.error(this.$i18n.t('messages.error'));
                    }
                    this.$Progress.finish();
                });
        },
        /**
         * Validate user inputs
         */
        fieldsAreEmpty() {
            if (this.trimString(this.password) === '' || this.trimString(this.password2) === '') {
                this.$toast.error(this.$i18n.t('messages.emptyFields'));
                return true;
            }
            return false;
        },

        /**
         * Validate user passwords
         */
        passwordsDoNotMatch() {
            if (this.trimString(this.password) !== this.trimString(this.password2)) {
                this.$toast.error(this.$i18n.t('messages.passwordsDoNotMatch'));
                return true;
            }
            return false;
        },

        /**
         * Reset input fileds values
         */
        resetInputs() {
            this.password = '';
            this.password2 = '';
            this.passwordTouched = false;
        },

        /**
         * Some browsers do not support trim() function
         * @return {*}
         * @param string
         */
        trimString(string) {
            return string.replace(/^\s+|\s+$/gm, '');
        },

        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        },

        togglePassword2Visibility() {
            this.showPassword2 = !this.showPassword2;
        },
    },
};
